<div id="navbar-header">
  <img src="/assets/bandeau.png" style="min-height: 200px;max-height: 600px;height: 30vh;z-index: 10;">
  <div id="navbar-buttons">
    <a class="nav-item" routerLink="/" routerLinkActive="nav-item-active" [routerLinkActiveOptions]="{exact: true}">Accueil</a>
    <a class="nav-item" href="https://docs.google.com/forms/d/1o27D3L-VQDfg5Byh-pzLflbR7Vi4KeeoC2-v3hk3ijQ/edit">Inscriptions</a>
    <a class="nav-item" routerLink="programme" routerLinkActive="nav-item-active">Programme</a>
    <a class="nav-item" routerLink="intervenants" routerLinkActive="nav-item-active">Intervenants</a>
    <a class="nav-item" routerLink="comment-y-acceder" routerLinkActive="nav-item-active">Comment y accéder</a>
  </div>
</div>